// Утилитарные функции для редактора счетов

/**
 * Нормализует дату к формату YYYY-MM-DD
 */
export const normalizeDate = (dateStr) => {
  return dateStr?.substring(0, 10) || '';
};

/**
 * Форматирует дату для отображения в формате DD.MM.YYYY
 */
export const formatDateToDisplay = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

/**
 * Форматирует дату для отображения (альтернативный вариант)
 */
export const formatDateForDisplay = (dateStr) => {
  const [year, month, day] = dateStr.split('-');
  return `${day}.${month}.${year}`;
};

/**
 * Обновляет или создает запись по дате
 */
export const updateOrCreateDateEntry = (totalsArray, date, field, subField, value) => {
  const newTotals = [...(totalsArray || [])];
  const entryIndex = newTotals.findIndex(t => (t.date || t.Date)?.split('T')[0] === date);

  if (entryIndex > -1) {
      const newEntry = { ...newTotals[entryIndex] };
      newEntry[field] = { ...(newEntry[field] || {}), [subField]: value };
      newTotals[entryIndex] = newEntry;
  } else {
      const newEntry = {
          date: date + "T00:00:00",
          periodTransactions: { debit: 0, credit: 0 },
          endingOfPeriod: { debit: 0, credit: 0 }
      };
      newEntry[field] = { ...(newEntry[field] || {}), [subField]: value };
      newTotals.push(newEntry);
  }
  return newTotals;
};

/**
 * Извлекает типы субконто из существующих контрагентов
 */
export const getSubcontoTypes = (account) => {
  let subconto1Type = null;
  let subconto2Type = null;
  
  for (let subAccount of (account.values || [])) {
    for (let counterparty of (subAccount.values || [])) {
      if (counterparty.subconto && counterparty.subconto.length > 0) {
        if (counterparty.subconto[0] && counterparty.subconto[0].type && !subconto1Type) {
          subconto1Type = counterparty.subconto[0].type;
        }
        if (counterparty.subconto[1] && counterparty.subconto[1].type && !subconto2Type) {
          subconto2Type = counterparty.subconto[1].type;
        }
        if (subconto1Type && subconto2Type) break;
      }
    }
    if (subconto1Type && subconto2Type) break;
  }
  
  return { subconto1Type, subconto2Type };
};

/**
 * Собирает все уникальные даты из счета
 */
export const collectDatesFromAccount = (account) => {
  const dates = new Set();
  
  (account.total || []).forEach((total) => {
    const date = total?.date;
    if (date) dates.add(date.split('T')[0]);
  });
  
  (account.values || []).forEach(sub => {
    (sub.total || []).forEach(total => {
      if(total.date) dates.add(total.date.split('T')[0]);
    });
    (sub.values || []).forEach(con => {
      (con.values || []).forEach(val => {
        if(val.date) dates.add(val.date.split('T')[0]);
      });
    });
  });
  
  return Array.from(dates).sort();
};

/**
 * Создает базовый элемент данных с нулевыми значениями
 */
export const createBaseTotalItem = (date) => ({
  date: date + "T00:00:00",
  periodTransactions: { debit: 0, credit: 0 },
  endingOfPeriod: { debit: 0, credit: 0 }
});